import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import { getLocaleString } from "lib/localization/vendor";
import { Circle as CircleStyle, Fill, Stroke, Style, Text, Icon } from "ol/style";

import { wordWrapString } from 'lib/utilities/misc';
import { assetURL } from 'lib/utilities/asset';

import StyleAnnotationFeatureStreetView from 'styles/script/styleannotationfeaturestreetview';
import StyleAnnotationArrowFeature from 'styles/script/styleannotationarrowfeature';

export default function StyleAnnotationFeature(feature: Feature<Geometry>, ) {
	const colorHex:string = (feature.get('Color') || _config.currentAnnotationColor) ?? '#00ff00';
	
	const StyleAnnotationTextFeature = () => {
		const fontSize:number = Number(feature.get('FontSize')) || 14;
		
		return [
			new Style({
				text: new Text({
					font: `${fontSize}px "Helvetica Neue", "Arial", san-serif`,
					textBaseline: "middle",
					backgroundFill: new Fill({
						color: "rgba(0,0,0,0.5)",
					}),
					fill: new Fill({
						color: colorHex,
					}),
					text: wordWrapString(feature.get('Label')) || 'No text in label',
					padding: [3, 2, 2, 2],
				}),
			}),
		];
	}
	
	const styles:any[] = [];
	
	styles.push(new Style({
		stroke: new Stroke({
			color: colorHex,
			width: 3
		}),
		fill: new Fill({
			color: "rgba(255, 255, 255, 0.2)",
		})
	}));
	
	if(feature.get('annotation') === 'text') {
		return StyleAnnotationTextFeature();
	}
	if(feature.get('annotation') === 'arrow') {
		styles.push(...StyleAnnotationArrowFeature(feature));
		return styles;
	}
	if(feature.get('annotation') === 'streetview') {
		return StyleAnnotationFeatureStreetView(feature);
	}

	
	styles.push(
		new Style({
			image: new CircleStyle({
				radius: 6,
				fill: new Fill({
					color: colorHex,
				}),
				stroke: new Stroke({
					color: "black",
					width: 1,
				}),
			}),
			text: new Text({
				font: 'bold 12px "Helvetica Neue", "Arial", san-serif',
				textBaseline: "middle",
				backgroundFill: new Fill({
					color: "rgba(0,0,0,0.5)",
				}),
				fill: new Fill({
					color: "white",
				}),
				text: feature.get('Label') ?? '',
				padding: [3, 2, 2, 2],
			}),
		}),
	);
	
	return styles;
}
